export function farloUiReviews(element) {

    const carouselElement = document.querySelector('.site-reviews__listing');
    if (carouselElement) {
        // Step 1: Clean Up Pre-existing Flickity Classes
        carouselElement.classList.remove('flickity-enabled', 'is-draggable');

        // Step 2: Remove 'is-selected' from all cells
        const cells = carouselElement.querySelectorAll('.flickity-cell');
        cells.forEach(cell => cell.classList.remove('is-selected'));


        // Step 4: Initialize Flickity after Images Load
        imagesLoaded(carouselElement, () => {
            handleResize();
        });

        // Step 5: Handle Window Resize with Debounce
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                handleResize();
            }, 150);
        });

        // Function to Initialize Flickity
        function initializeFlickity() {

            flkty = new Flickity(carouselElement, {
                cellAlign: 'center',
                pageDots: false,
                prevNextButtons: true,
                wrapAround: true,
                groupCells: false,
                freeScroll: true,
                contain: false,
                draggable: true,
                scrollSnap: true,
                adaptiveHeight: false, // Adjust height based on selected cell
            });

            // Listen to Flickity events for debugging
            flkty.on('ready', () => {
                flkty.resize();
            });

            // Force Flickity to recalculate layout after a short delay
            setTimeout(() => {
                flkty.resize();
            }, 100); // Adjust the delay as necessary



        }

        // Function to Handle Resize and Initialize/Destroy Flickity Accordingly
        function handleResize() {

            initializeFlickity();
        }


    }

    // Horizontal scrolling with mouse wheel, but allow vertical scrolling
    const onWheel = (event) => {
        // Check if the horizontal scroll delta (event.deltaX) is significant
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
            // Prevent default scroll only when scrolling horizontally
            event.preventDefault();

            if (event.deltaX < 0) {
                flkty.previous();  // Scroll left (back)
            } else if (event.deltaX > 0) {
                flkty.next();  // Scroll right (forward)
            }
        }
    };

    // Add touch handling for mobile devices
    let startX, startY;

    const onTouchStart = (event) => {
        const touch = event.touches[0];
        startX = touch.pageX;
        startY = touch.pageY;
    };

    const onTouchMove = (event) => {
        const touch = event.touches[0];
        const deltaX = touch.pageX - startX;
        const deltaY = touch.pageY - startY;

        // Check if horizontal movement is larger than vertical movement
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
            // Prevent vertical scrolling if it's a horizontal swipe
            event.preventDefault();
            // Move Flickity horizontally based on swipe
            if (deltaX < 0) {
                flkty.next();  // Swipe left to scroll right
            } else {
                flkty.previous();  // Swipe right to scroll left
            }
        }
        // Otherwise, let vertical scrolling proceed as normal
    };

    element.addEventListener('wheel', onWheel);
    element.addEventListener('touchstart', onTouchStart);
    element.addEventListener('touchmove', onTouchMove);

    window.addEventListener('resize', onResize);
}